export default {
	props: {
		view_type: {
			// принимает три значения: filter, card, list
			type: String,
		},
		show_in_popup: {}, // при показе в попапе например меняем z-index
		field_meta: {
			type: Object,
		},
		is_disabled: {
			// пропс используется например во время сохранения из списка
			type: Boolean,
			default: false,
		},
		is_new_record: {
			default: false,
		},
		isForceStatic: {
			type: Boolean,
			default: false,
		},
		brokenLinks: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		c_value: {
			// c_value в data() ещё не готова! Надо использовать $props.value. А в шаблоне и далее - можно c_value
			get() {
				//console.log('GET c_value');
				return this.value;
			},
			set(newVal) {
				this.$emit('update:value', newVal);
			},
		},
		c_srv_options: {
			// сгенеренный на сервере список опций для выпадушки или мультивыбора
			get() {
				// на самом деле srv_options сидят внутри filter/list/card
				// но обработчики в p_list/p_card пихают их в field_meta
				// UPD!!! srv_options переехали на уровень поля из filter/list/card
				// если пихнем их обратно CTRL+F "srv_options переехали"
				return this.$props.field_meta.srv_options || [];
			},
		},
		c_ctrlParams: {
			get() {
				// на самом деле ctrl_params сидят внутри filter/list/card
				// но обработчики в p_list/p_card пихают их в field_meta
				return this.$props.field_meta.ctrlParams || {};
			},
		},
		// Атрибуты для тестирования
		c_test_attrs() {
			return {
				'test-dbcolname': this.$props.field_meta.dbcolname,
				'test-ctrlcode': this.$props.field_meta.ctrlCode,
				'data-test-id': this.$props.field_meta.ctrlCode,
			};
		},
	},
	methods: {
		// Контрол должен уметь сохраняться из списка
		// события разные - например текстовые поля сохраняются по потере фокуса (blur)
		// а радиобатоны (контрол Флаг) - по change
		// контрол всплывающего выбора - по выбору из окна либо при потере фокуса при ручном вводе ID
		// и так далее
		mixin_saveEvent() {
			this.$emit('save_event');
		},
		// optionalPayload нужен для
		// 0) отладки - чтобы понимать откуда/как случилось событие
		// 1) черновиков - к примеру контрол справочников отдает тупо айди, этого недостаточно и нужно ещё имя
		// 2) контролов которые меняют соседние поля, например, адрес ГАР
		mixin_inputEvent(optionalPayload) {
			this.$emit('input_event', optionalPayload);

			// PIRS-2-12326 - необходимо проверять, что значение отличается от дефолтного в текущий момент
			if (this.field_meta.ctrlParams.defaultValue) {
				this.$emit('has_changes');
			}
		},
		/**
		 * Стандартный способ обработки любых ошибок контролов
		 * @param {Error} error Объект ошибки
		 */
		mixin_errHandler(error) {
			this.$data.errText = error.toString();
			throw error;
		},
	},
};
